import { VStack } from '../../../layouts/stack.layout';
import TextFormGroup from '../../inputs/text.formGroup';
import Text from '../../../typography/v2/text';

export default function AccountAuth({ username }: { username: string }) {
  return (
    <VStack align="center" extensions="w-full" gap="base">
      <VStack extensions="w-full" align="center" gap="xs">
        <VStack
          align="center"
          extensions="justify-center w-[80px] h-[80px] bg-[#2E2E2E] rounded-full"
        >
          <div />
        </VStack>
        <Text>@{username}</Text>
      </VStack>
      <TextFormGroup name="email" label="email" type="text" />
      <TextFormGroup name="password" label="password" type="password" />
      <TextFormGroup
        name="passwordVerification"
        label="password verfication"
        type="password"
      />
    </VStack>
  );
}
